import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AgGridAngular } from 'ag-grid-angular';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';
import { UserNewPaymentComponent } from '../user-new-payment/user-new-payment.component';
import { UserNewSettlementComponent } from '../user-new-settlement/user-new-settlement.component';
import Swal from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'app-usr-new-followup',
  templateUrl: './usr-new-followup.component.html',
  styleUrls: ['./usr-new-followup.component.css']
})
export class UsrNewFollowupComponent implements OnInit {
  @ViewChild('agGrid', { static: false }) agGrid: AgGridAngular;
  FollowUpcolumnDefs = [
    // {headerName: 'ID', field: '_id', width: 250, checkboxSelection: true,headerCheckboxSelection: true,sortable: true, filter: true},
    {
      headerName: 'Log Date', field: 'log_date', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
        return moment(data.value).format('LLLL');
      }
    },
    { headerName: 'Log Type', field: 'log_type', resizable: true, sortable: true, filter: true },
    { headerName: 'FollowUp Date', field: 'fdate', resizable: true, sortable: true, filter: true },
    { headerName: 'Main Status', field: 'mstatus', resizable: true, sortable: true, filter: true },
    { headerName: 'Sub Status', field: 'substatus', resizable: true, sortable: true, filter: true },
    { headerName: 'Remarks', field: 'remarks', resizable: true, sortable: true, filter: true },
    { headerName: 'Bank Code', field: 'bcode', resizable: true, sortable: true, filter: true },
    { headerName: 'Action To Taken', field: 'actiontotake', resizable: true, sortable: true, filter: true },
    {
      headerName: 'Attachment URL', field: 'attachment_url', resizable: true, sortable: true, filter: true,
      cellRenderer: (data) => {
        if (data.value && data.value !== '') {
          return `<a href="${data.value}" target="_blank" style="color: #007bff; text-decoration: none;">View</a>`;
        }
        return '';
      }
    },
    {
      headerName: 'Created By', field: 'createdby', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
        return data.value.name;
      }
    },

    { headerName: 'Labour Card', field: 'labour_card', resizable: true, sortable: true, filter: true },
    { headerName: 'DED Number', field: 'ded_number', resizable: true, sortable: true, filter: true },
    { headerName: 'MOL Status', field: 'mol_status', resizable: true, sortable: true, filter: true },
    { headerName: 'DED Status', field: 'ded_status', resizable: true, sortable: true, filter: true },
    { headerName: 'UID Status', field: 'uid_status', resizable: true, sortable: true, filter: true },
    { headerName: 'UID Number', field: 'uid_number', resizable: true, sortable: true, filter: true },


    { headerName: 'Creator Name', field: 'creator_name', resizable: true, sortable: true, filter: true },
    { headerName: 'Customer ID', field: 'customer_id', resizable: true, sortable: true, filter: true },
    { headerName: 'Client ID', field: 'client_id', resizable: true, sortable: true, filter: true },
    { headerName: 'Bank ID', field: 'bank_id', resizable: true, sortable: true, filter: true },
    { headerName: 'Product ID', field: 'product_id', resizable: true, sortable: true, filter: true },
    { headerName: 'Portfolio ID', field: 'portfolio_id', resizable: true, sortable: true, filter: true },
    { headerName: 'Bucket ID', field: 'bucket_id', resizable: true, sortable: true, filter: true },
    { headerName: 'Fintresle ID', field: 'finterstal_id', resizable: true, sortable: true, filter: true },
    { headerName: 'Passport Number', field: 'passport_no', resizable: true, sortable: true, filter: true },
    {
      headerName: 'Created At', field: 'createdAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
        return moment(data.value).format('LLLL');
      }
    },
    {
      headerName: 'Update At', field: 'updatedAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
        return moment(data.value).format('LLLL');
      }
    },
    {
      headerName: 'Options', width: 120, cellRenderer: function (params) {
        return "";
      }
    },
  ];

  FollowUpForm: UntypedFormGroup;
  areaCodeList: any;
  bankCodeList: any;
  fieldvisitCodeList: any;
  mStatusList: any;
  sStatusList: any;
  FollowUpList = [];
  login_Details: any;
  TracingToolsList: any;
  actionstakenList: any;
  userFilter: any = { mstatus_id: '' };
  userFilter2: any = { fvterritary: '' };
  LogTypeList: any[];
  uploaded: boolean;
  showPTP: boolean;
  Linklist = [];
  link: any;
  StopFollowup_Status: Boolean;
  loader_view = false;

  check_allocation_status: any;

  log_type = "";
  no_mapped_account = "";
  request_type = "";
  territory = "";
  fvarea = "";
  remarks = "";
  mstatus = "";
  substatus = "";
  fdate = "";
  bcode = "";
  ptp_amount = "";
  ptp_status = "";
  actiontotake = "";
  actiontaken = "";
  tracingtool = "";
  tracinglink = "";
  labour_card = "";
  ded_number = "";
  mol_status = "";
  ded_status = "";
  uid_status = "";
  uid_number = "";
  contact_email = "";
  contact_mobile = "";
  f_date = "";


  constructor(public dialog: MatDialog, private formBuilder: UntypedFormBuilder, private _api: ApiService, @Inject(SESSION_STORAGE) private storage: StorageService,) {
    this.FollowUpForm = this.formBuilder.group({
      _id: ['', Validators.required],
      log_date: ['', Validators.required],
      log_type: ['', Validators.required],
      no_mapped_account: [''],
      request_type: [''],
      territory: [''],
      fvarea: [''],
      remarks: ['', Validators.required],
      mstatus: ['', Validators.required],
      substatus: ['', Validators.required],
      fdate: ['', Validators.required],
      bcode: [''],
      ptp_amount: [''],
      ptp_status: [''],
      actiontotake: [''],
      actiontaken: [''],
      tracingtool: [''],
      tracinglink: [''],
      labour_card: [''],
      ded_number: [''],
      mol_status: [''],
      ded_status: [''],
      uid_status: [''],
      uid_number: [''],
      contact_email: [''],
      contact_mobile: [''],
      attachment_url: [''],
      createdby: [''],
      creator_name: [''],
      f_date: [''],
      customer_id: [''],
      client_id: [''],
      bank_id: [''],
      product_id: [''],
      portfolio_id: [''],
      bucket_id: [''],
      finterstal_id: [''],
      passport_no: ['', ],
      bank_name: [''],
      portfolio_type: [''],

    })
  }

  ngOnInit(): void {
    if (localStorage.getItem('StopFollowUp') == 'true' || localStorage.getItem('MarkCompleted') == 'true') {
      this.StopFollowup_Status = false;
    } else {
      this.StopFollowup_Status = false;
    }
    // console.log(this.StopFollowup_Status);


    let logindetail = this.getFromLocal("login_Details");
    // console.log(logindetail);
    let values = {
      "finterstal_id": localStorage.getItem("Fintrestle_ID"),
      "assigned_to": logindetail._id
    }
    // console.log(values);
    this._api.check_allocation_status(values).subscribe(data => {
      if (data['Code'] == 200) {
        let check_allocation = data['Data'];
        // console.log(check_allocation);
        if (check_allocation == null) {
          this.check_allocation_status = false;
        } else {
          this.check_allocation_status = true;
        }
        // console.log(this.check_allocation_status);
      } else {
      }
    });



    this.showPTP = false;
    this.f_date = "" + new Date();

    this._api.getlist_area_code().subscribe(data => {
      if (data['Code'] == 200) {
        this.areaCodeList = data['Data'];
      } else {
        this.areaCodeList = [];
      }
    });
    this._api.getlist_bank_code().subscribe(data => {
      if (data['Code'] == 200) {
        this.bankCodeList = data['Data'];
      } else {
        this.bankCodeList = [];
      }
    });
    this._api.getlist_fieldvisit_code().subscribe(data => {
      if (data['Code'] == 200) {
        this.fieldvisitCodeList = data['Data'];
      } else {
        this.fieldvisitCodeList = [];
      }
    });
    this._api.getlist_mainStatus_code().subscribe(data => {
      if (data['Code'] == 200) {
        this.mStatusList = data['Data'];
      } else {
        this.mStatusList = [];
      }
    });

    this._api.getlist_subStatus_code().subscribe(data => {
      if (data['Code'] == 200) {
        this.sStatusList = data['Data'];
      } else {
        this.sStatusList = [];
      }
    });

    this._api.getlist_tracingtools().subscribe(data => {
      if (data['Code'] == 200) {
        this.TracingToolsList = data['Data'];
      } else {
        this.TracingToolsList = [];
      }
    });

    this._api.getlist_actionstaken().subscribe(data => {
      if (data['Code'] == 200) {
        this.actionstakenList = data['Data'];
      } else {
        this.actionstakenList = [];
      }
    });

    this._api.getlist_new_logtype().subscribe(data => {
      if (data['Code'] == 200) {
        this.LogTypeList = data['Data'];
      } else {
        this.LogTypeList = [];
      }
    });



    this.login_Details = this.getFromLocal("login_Details");
    this.FollowUpForm.patchValue({
      createdby: this.login_Details._id,
      creator_name: this.login_Details.name,
      customer_id: localStorage.getItem("Fintrestle_ID"),
      client_id: localStorage.getItem("Client_ID"),
      bank_id: localStorage.getItem("Bank_ID"),
      product_id: localStorage.getItem("Product_ID"),
      portfolio_id: localStorage.getItem("Portfolio_ID"),
      bucket_id: localStorage.getItem("Bucket_ID"),
      finterstal_id: localStorage.getItem("Fintrestle_ID"),
      passport_no: localStorage.getItem("Passport_Number"),
    })
    this._api.getlist_new_FollowUp(localStorage.getItem("Fintrestle_ID")).subscribe(data => {
      if (data['Code'] == 200) {
        this.FollowUpList = data['Data'];
      } else {
        this.FollowUpList = null;
      }
    });
  }

  getFile(event) {
    this.uploaded = false;
    const File = event.target.files[0];
    // console.log(File);
    this._api.uploadFile(File).subscribe(data => {
      if (data['Code'] == 200) {
        this.FollowUpForm.patchValue({
          attachment_url: data['Data']
        })
        this.uploaded = true;
      } else {
        this.FollowUpForm.patchValue({
          attachment_url: data['Data']
        })
        this.uploaded = false;
      }
    })
  }

  onMstatus(event) {
    this.userFilter.mstatus_id = event.target.value;
    // console.log(event.target.value);

    if (event.target.value == "PTP") {
      this.showPTP = true;
    } else {
      this.showPTP = false;
    }
  }

  onterritory(event) {
    this.userFilter2.fvterritary = event.tagert.value;
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }

  ShowPaymentsRecord() {
    const dialogRef = this.dialog.open(UserNewPaymentComponent, {
      height: '550px',
      width: '90%', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }


  ShowSettlementsRecord() {
    const dialogRef = this.dialog.open(UserNewSettlementComponent, {
      height: '550px',
      width: '90%', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  addNewFollowUp() {


    if (this.check_allocation_status == false) {
      alert("You don't have the access");
    } else {
      this.loader_view = true;
      this.FollowUpForm.patchValue({
        _id: new Date().getTime(),
        log_date: new Date()
      });
      console.log(this.StopFollowup_Status);
      if (this.FollowUpForm.valid && !this.StopFollowup_Status) {
        console.log(this.FollowUpForm.value);
        let temp = this.FollowUpForm.value;
        if (temp.mstatus == "PTP") {
          if (temp.ptp_amount == '' || temp.ptp_status == '') {
            alert('Form No Valid');
            this.loader_view = false;
          } else {
            this.FollowUpForm.controls["f_date"].setValue(new Date(this.f_date));
            let ptp_statuss = temp.ptp_status + "T00:00:00.000Z";
            this.FollowUpForm.controls["ptp_status"].setValue(ptp_statuss);
            this._api.create_new_FollowUp(this.FollowUpForm.value).subscribe(data => {
              if (data['Code'] == 200) {
                this.onPagereload();
                alert(data['Message']);
                this.cleardata();
              } else {
                alert(data['Message']);
              }
              this.loader_view = false;
            });
          }
        } else {
          this.FollowUpForm.controls["f_date"].setValue(new Date(this.f_date));
          console.log("this.FollowUpForm",this.FollowUpForm);
          
          this._api.create_new_FollowUp(this.FollowUpForm.value).subscribe(data => {
            if (data['Code'] == 200) {
              this.onPagereload();
              console.log("this.onPagereload()",this.onPagereload());
              
              alert(data['Message']);
              this.cleardata();
            } else {
              alert(data['Message']);
            }
            this.loader_view = false;
          });
        }



      } else {
        if (this.StopFollowup_Status) {
          alert('Followup Stopped For this Account..!');
          this.loader_view = false;
        } else {
          alert('Form No Valid');
          this.loader_view = false;
        }
        console.log(this.FollowUpForm.value);


      }

    }
  }

  onPagereload() {
    this._api.getlist_new_FollowUp(localStorage.getItem("Fintrestle_ID")).subscribe(data => {
      if (data['Code'] == 200) {
        this.FollowUpList = data['Data'];
      } else {
        this.FollowUpList = null;
      }
    });
  }

  close() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to close it!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.dialog.closeAll();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    })

  }


  addnewLink() {
    this.Linklist.push({ link: this.link, tool: this.FollowUpForm.value.tracingtool });
    this.FollowUpForm.patchValue({
      tracinglink: this.Linklist
    })
  }

  cleardata() {
    let temp = this.FollowUpForm.value;
    console.log(this.FollowUpForm.value);
    this.log_type = "";
    this.no_mapped_account = "";
    this.request_type = "";
    this.territory = "";
    this.fvarea = "";
    this.remarks = "";
    this.mstatus = "";
    this.substatus = "";
    this.fdate = "";
    this.bcode = "";
    this.ptp_amount = "";
    this.ptp_status = "";
    this.actiontotake = "";
    this.actiontaken = "";
    this.tracingtool = "";
    this.tracinglink = "";
    this.labour_card = "";
    this.ded_number = "";
    this.mol_status = "";
    this.ded_status = "";
    this.uid_status = "";
    this.uid_number = "";
    this.contact_email = "";
    this.contact_mobile = "";
    this.f_date = '';
    // console.log(this.FollowUpForm.value);

  }

}
